import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeOzonMarket } from '../../../actions/ozon';
import { addOzonOrdersMap } from '../../../actions/ozonOrders';
import { uiChangeWbViewSize } from '../../../actions/ui';
import MarketOzonApi from '../../../API/market/ozon-api';
import PostingsOzonApi from '../../../API/shipment/postingsOzon-api';
import { Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, CheckButton, ExportExcelFileButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { Select } from '../../../components/Basic/Inputs';
import { H1, Text } from '../../../components/Basic/WrapsStyle';
import {
  B_MAX_EXPRESS,
  MAP_OZON_SKLAD_NAME,
  MAP_OZON_SKLAD_SALE_SCHAME,
  MAP_SKLAD_RUS,
  OZON_1,
  OZON_1_EKB,
  OZON_1_FBO,
  OZON_2,
  OZON_2_EKB,
  OZON_2_FBO,
  OZON_3,
  OZON_3_EKB,
  OZON_3_FBO,
  OZON_4,
  OZON_4_EKB,
  OZON_4_FBO,
  OZON_5,
  OZON_5_EKB,
  OZON_5_FBO,
  OZON_6,
  OZON_6_EKB,
  OZON_6_FBO,
  OZON_7,
  OZON_7_EKB,
  OZON_7_FBO,
  OZON_MARKETS_MAP,
  TYPE_BUTTONS
} from '../../../constans';
import { formFullDate, getDate } from '../../../utils';
import DateButton from './DateButton';
import OzonShipPopUp from './ShipPopUp';
import styles from './styles.module.scss';
import OzonTableOrders from './TableOrders';
import OzonTableSizes from './TableSizes';

export const WIDTH_OZON_ORDERS = [
  '150px',
  '400px',
  '130px',
  '100px',
  '150px',
  '180px',
  '120px',
  '80px',
  '180px',
  '250px',
];

let MARKET_LIST = [
  OZON_1,
  OZON_2,
  OZON_3,
  OZON_4,
  OZON_5,
  OZON_6,
  OZON_7,
  OZON_1_EKB,
  OZON_2_EKB,
  OZON_3_EKB,
  OZON_4_EKB,
  OZON_5_EKB,
  OZON_6_EKB,
  OZON_7_EKB,
];
let MARKET_LIST_ADMIN = [
  ...MARKET_LIST,
  OZON_1_FBO,
  OZON_2_FBO,
  OZON_3_FBO,
  OZON_4_FBO,
  OZON_5_FBO,
  OZON_6_FBO,
  OZON_7_FBO,
];

const LIST_STATUS = [
  { status: 'awaiting_packaging', title: 'Ожидает сборки' },
  { status: 'awaiting_deliver', title: 'Ожидает отгрузки' },
];
const LIST_STATUS_ADMIN = [
  ...LIST_STATUS,
  { status: 'delivering', title: 'Доставляется' },
  { status: 'delivered', title: 'Доставлено' },
  { status: 'cancelled', title: 'Отменено' },
];

function OzonPage({ ...props }) {
  const [status, setStatus] = useState({ status: 'awaiting_packaging', title: 'Ожидает сборки' });
  const shop = useSelector((store) => store.ozon.market);
  const [postings, setPostings] = useState([]);
  const [skladName, setSkladName] = useState('Не выбран');
  const [shipped, setSipped] = useState(false);
  const [showShipment, setShowShipment] = useState(false);

  const [map, setMap] = useState({ ozon1: {}, ozon2: {}, ozon3: {}, ozon4: {}, ozon5: {}, ozon6: {}, ozon7: {} });

  const { is_check_size } = useSelector((store) => store.ui);

  //const [access, setAccessf] = useState({});
  const [select, setSelect] = useState('Все отправления');
  const user = useSelector((store) => store.user);

  const [groups, setGroups] = useState({});
  const [calculation, setCalculation] = useState({
    'Все отправления': { all: 0, allCom: 0, allProfit: 0, allPurchase: 0 },
  });

  const dispatch = useDispatch();

  const loadOrders = async () => {
    await PostingsOzonApi.getOrders({
      data: {
        shop: skladName !== 'Не выбран' ? undefined : OZON_MARKETS_MAP[shop],
        status: status.status,
        skladName: skladName !== 'Не выбран' ? MAP_SKLAD_RUS[skladName] : MAP_OZON_SKLAD_NAME[shop],
        saleSchema: MAP_OZON_SKLAD_SALE_SCHAME[shop],
      }
    }).then((r) => {
      let postings = r.postings;
      setMap(r.cardsMapByShop);
      let all_postings = [];
      Object.keys(postings).forEach((date) => {
        all_postings = [...all_postings, ...postings[date]];
      });

      setGroups({ 'Все отправления': all_postings, ...postings });
    });
  };

  const shipmentOrders = async (shipmentId, orderId) => {
    const group_select = groups[select] || [];

    await PostingsOzonApi.shipOrders({
      data: {
        orders: group_select,
        shop: skladName !== 'Не выбран' ? undefined : OZON_MARKETS_MAP[shop],
        orderId, shipmentId,
      }
    });
    setSipped(false);
    setSelect('Все отправления');
  };

  useEffect(() => {
    loadOrders();

    return () => {
      dispatch(addOzonOrdersMap({}));
    };
  }, [shop, status, skladName]);

  const onChangeProduct = async (offer_id, shop, key, value) => {
    // if (map[offer_id][key] === value) {
    //   return;
    // }
    let setCard = (card) => {
      setMap({ ...map, [shop]: { ...map[shop], [card.offer_id]: card } });
    };

    if (key === 'stock') {
      return await MarketOzonApi.changeStock({ data: { shop, offer_id, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'price') {
      return await MarketOzonApi.changePrice({ data: { shop, offer_id, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'percent' || key === 'min_rub') {
      return await MarketOzonApi.changeMarginality({ data: { shop, offer_id, field: key, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'archive') {
      return await MarketOzonApi.changeArchive({ data: { shop, offerIds: [offer_id], value } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketOzonApi.changeStopBrand({ data: { shop, offerIds: [offer_id], value } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    return await MarketOzonApi.changeCard({ data: { shop, offer_id, field: key, value } })
      .then((r) => {
        setCard(r.card);
      })
      .catch((e) => console.log(e));
  };

  const calcDownloadedData = useCallback(() => {
    const d = groups[select] || [];

    const r = [];
    // eslint-disable-next-line array-callback-return
    d.map((order) => {
      const c = {
        'Номер отправления': order.posting_number,
        'Принят в обработку': formFullDate(order.in_process_at),
        'Дата отгрузки': formFullDate(order.shipment_date),
        Статус: order.status,
      };
      order.products.map((p) => {
        r.push({
          ...c,
          Магазин: order.shop,
          'Город отгрузки': order.skladName,
          'Наименование товара': p.name,
          Артикул: p.offer_id,
          'Итоговая стоимость товара': parseFloat(p.price),
          Количество: p.quantity,
        });
      });
    });

    return r;
  }, [postings, groups, select]);


  const isOwner = user.role === 'owner' || user.role === 'admin';

  useEffect(() => {
    const keys = Object.keys(groups);
    const new_calc = {};
    keys.forEach((key) => {
      const orders = groups[key];
      const res = orders.reduce(
        ({ all, allCom, allProfit, allPurchase }, order) => {
          const oneOrder = order.products.reduce(
            ({ sum, com, profit, purchase }, p) => {
              sum += parseFloat(p.price) * p.quantity;

              com += p.commission?.common?.rub * p.quantity;
              profit += p.profit?.rub * p.quantity;
              purchase += map[order.shop][p.offer_id]?.purchase * p.quantity * map[order.shop][p.offer_id]?.quantity;

              return { sum, com, profit, purchase };
            },
            { sum: 0, com: 0, profit: 0, purchase: 0 },
          );
          return {
            all: all + oneOrder.sum,
            allCom: allCom + oneOrder.com,
            allProfit: allProfit + oneOrder.profit,
            allPurchase: allPurchase + oneOrder.purchase,
          };
        },
        { all: 0, allCom: 0, allProfit: 0, allPurchase: 0 },
      );

      new_calc[key] = res;
    });

    setCalculation(new_calc);
  }, [map, groups]);

  const isExpress = shop === B_MAX_EXPRESS;

  return (
    <>
      <Content>
        <H1>Отправления со склада</H1>
        <Row>
          <WhiteBlock style={{ marginRight: '15px' }}>
            <Row style={{ marginBottom: '20px' }} >
              <Select
                label="Выбрать город"
                select={skladName}
                big={true}
                width="200px"
                onSelect={(m) => {
                  setPostings([]);
                  setSkladName(m);
                }}
                list={['Москва', 'Екатеринбург', 'Не выбран']}
              />
            </Row>

            <Row>
              <div style={{ marginRight: '15px' }}>
                <Select
                  label="Выбрать магазин"
                  select={skladName === 'Не выбран' ? shop : 'Все'}
                  onSelect={(m) => {
                    setPostings([]);
                    dispatch(changeOzonMarket(m));
                  }}
                  width={'200px'}
                  disabled={skladName !== 'Не выбран'}
                  list={isOwner ? MARKET_LIST_ADMIN : MARKET_LIST}
                />
              </div>
              <div>
                <Select
                  label="Выбрать статус"
                  select={status}
                  width="200px"
                  valueFn={(v) => v.title}
                  onSelect={(m) => {
                    setPostings([]);
                    setStatus(m);
                  }}
                  list={isOwner ? LIST_STATUS_ADMIN : LIST_STATUS}
                />
              </div>

            </Row>

          </WhiteBlock>
        </Row>
        <Row style={{ marginBottom: '40px' }}>
          <Button
            type={TYPE_BUTTONS.GREEN}
            onClick={() => setSipped(true)}
            style={{ marginRight: '10px' }}
            disabled={status.status === 'awaiting_deliver'}
          >
            Собрать
          </Button>

          <ExportExcelFileButton
            style={{ marginLeft: '10px' }}
            sheets={['Заказы', 'Данные', 'Этикетки']}
            filename={`Ozon orders ${shop} - ${(groups[select] || []).length} (${formFullDate(new Date())})`}
            data={{
              Заказы: calcDownloadedData(),
            }}
            buttonTitle="Скачать список заказов"
          />
        </Row>
        <Row spaceBetween={true}>
          <Row className={styles.row_date}>
            {Object.keys(groups).length > 0 &&
              [Object.keys(groups)[0], ...[...Object.keys(groups).slice(1)].sort()].map((date, key) => {
                return (
                  <DateButton
                    date={key ? getDate(date) : date}
                    key={date}
                    selected={select === date}
                    onClick={() => setSelect(date)}
                    num={groups[date].length}
                  />
                );
              })}
          </Row>
          <Row style={{ width: 'auto' }}>
            <CheckButton
              checked={is_check_size}
              onSelect={() => dispatch(uiChangeWbViewSize(!is_check_size))}
              style={{ marginRight: '15px' }}
            />
            <Text style={{ marginTop: '4px', marginBottom: '5px' }}>Проверка габаритов</Text>
          </Row>
        </Row>
        {!is_check_size ? (
          <OzonTableOrders
            calculation={calculation}
            isOwner={isOwner}
            isExpress={isExpress}
            groups={groups}
            select={select}
            skladName={MAP_SKLAD_RUS[skladName]}
            map={map}
            shop={shop}
            onChange={onChangeProduct}
          />
        ) : (
          <OzonTableSizes
            calculation={calculation}
            isOwner={isOwner}
            isExpress={isExpress}
            groups={groups}
            skladName={MAP_SKLAD_RUS[skladName]}
            select={select}
            map={map}
            onChange={onChangeProduct}
          />
        )}
      </Content>
      {shipped && (
        <OzonShipPopUp skladName={skladName} market={shop} day={select} clickOk={shipmentOrders} close={() => setSipped(false)} />
      )}
    </>
  );
}

export default OzonPage;
